/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { css } from 'emotion';
import { border, background } from '@guardian/src-foundations/palette';
import { headline, textSans } from '@guardian/src-foundations/typography';
import { Button } from '@guardian/src-button';
import { SvgCheckmark } from '@guardian/src-icons';
import { space } from '@guardian/src-foundations';
const roleTextSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return textSans.medium();
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return textSans.small();
        }
    }
};
const roleHeadlineSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return headline.xsmall();
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return headline.xxsmall();
        }
    }
};
const roleButtonSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return 'small';
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return 'xsmall';
        }
    }
};
const roleButtonText = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase':
        case 'halfWidth':
        case 'supporting': {
            return 'Allow and continue';
        }
        case 'thumbnail': {
            return 'Allow';
        }
    }
};
const shouldDisplayOverlay = (isTracking, isOverlayClicked, isInABTestVariant) => {
    if (!isTracking) {
        return false;
    }
    if (isOverlayClicked) {
        return false;
    }
    return isInABTestVariant;
};
const isInABTestVariant = (abTestConfig) => {
    return abTestConfig.clickToViewVariant === 'variant';
};
export const ClickToView = ({ children, role = 'inline', onAccept, isTracking, source, sourceDomain = 'unknown', abTests, }) => {
    const [isOverlayClicked, setIsOverlayClicked] = useState(false);
    const handleClick = () => {
        setIsOverlayClicked(true);
        if (onAccept) {
            setTimeout(() => onAccept());
        }
    };
    const textSize = roleTextSize(role);
    if (shouldDisplayOverlay(isTracking, isOverlayClicked, isInABTestVariant(abTests))) {
        return (React.createElement("div", { className: css `
					width: 100%;
					background: ${background.secondary};
					border: 1px solid ${border.primary};
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: ${space[3]}px;
					margin-bottom: 8px;
				` },
            React.createElement("div", { className: css `
						${roleHeadlineSize(role)}
						margin-bottom: 8px;
					` }, source
                ? `Allow ${source} content?`
                : 'Allow content provided by a third party?'),
            React.createElement("div", { className: css `
						${textSize}
						a {
							${textSize}
						}
						p {
							margin-bottom: 8px;
						}
					` }, source ? (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "This article includes content provided by",
                    ' ',
                    source,
                    ". We ask for your permission before anything is loaded, as they may be using cookies and other technologies."),
                React.createElement("p", null, "To view this content, click 'Allow and continue'."))) : (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    "This article includes content hosted on",
                    ' ',
                    sourceDomain,
                    ". We ask for your permission before anything is loaded, as the provider may be using cookies and other technologies."),
                React.createElement("p", null, "To view this content, click 'Allow and continue'.")))),
            React.createElement("div", null,
                React.createElement(Button, { priority: "primary", size: roleButtonSize(role), icon: React.createElement(SvgCheckmark, null), iconSide: "left", onClick: () => handleClick() }, roleButtonText(role)))));
    }
    return React.createElement(React.Fragment, null, children);
};
